const zh = {
  Language: {
    vi: "越南语",
    en: "英语",
    zh: "简体中文",
    "zh-HK": "繁體中文（香港）",
    ko: "韩语",
    ja: "日语",
  },
  NAVS: {
    home: "首页",
    ourHotels: "我们的酒店",
    contactUs: "联系我们",
    aboutUs: "关于我们",
    sustainability: "可持续发展",
    careers: "职业发展",
    discoverOurHotels: "探索我们的酒店",
    amanakiSaigonBoutique: "Amanaki 西贡精品酒店",
    amanakiThaoDien: "Amanaki 草甸酒店",
    amanakiHotel: "Amanaki 酒店",
    theHotel: "酒店",
    brandStory: "品牌故事",
    artAmanaki: "艺术与 Amanaki",
    rooms: "客房",
    wellness: "健康养生",
    dining: "餐饮",
    events: "活动",
    offers: "优惠",
    discoverSaigon: "探索西贡",
  },
  Form: {
    required: "必填项",
    emailInvalid: "邮箱格式无效。",
    mustBeAccept: "必须接受",
    placeholderFirstName: "名",
    placeholderLastName: "姓",
    placeholderEmail: "邮箱地址",
    placeholderPhone: "电话号码",
    placeholderEnquiry: "选择咨询类型",
    placeholderWhichHotel: "您想联系哪家酒店？",
    placeholderMessage: "您的留言",
    placeholderDepartureDate: "离店日期",
    placeholderArrivalDate: "入住日期",
    placeholderRoomType: "选择房型",
    placeholderAll: "全部",
    labelPhone: "电话",
  },
  Options: {
    Enquiry: {
      hotelReservation: "酒店预订",
      wellnessReservation: "健康养生预订",
      meetingsEvents: "会议与活动",
      pressMedia: "媒体与新闻",
      generalEnquiryFeedback: "一般咨询与反馈",
    },
  },
  Notification: {
    submitSuccess: "您的信息已提交。",
  },
  Footer: {
    name: "Amanaki 酒店",
    address: "草甸区，守德市，胡志明市",
    address10: "10 Nguyen Dang Giai, 草甸区, 胡志明市, 越南",
    address65: "65 Ho Tung Mau, 本义区, 第一区, 胡志明市",
    email: "info@amanaki.vn",
    email10: "info@amanaki.vn",
    email65: "sales@amanakihotels.com",
    phone: "(+84) 82 362 4488",
    phone10: "(+84) 82 362 4488",
    phone65: "(+84) 28 363 4488",
    tel: "电话",
    ourHotels: "我们的酒店",
    thaoDien: "Amanaki 草甸酒店",
    boutiqueSaigon: "Amanaki 西贡精品酒店",
    amanakiHotels: "Amanaki 酒店",
    getToKnowUs: "了解我们",
    whoWeAre: "关于我们",
    sustainabilityImpact: "可持续发展影响",
    ourStories: "我们的故事",
    explore: "探索",
    careers: "职业发展",
    ourOffice: "我们的办公室",
    getInTouch: "保持联系",
    contactUs: "联系我们",
    copyright: "© 2023 Amanaki 酒店。保留所有权利。",
    privacyPolicy: "隐私政策",
    adCookiePolicy: "广告和 Cookie 政策",
    legalNotices: "法律声明",
  },
  Header: {
    selectAHotel: "选择酒店",
    aboutAmanaki: "关于 Amanaki",
    ourStories: "博客",
    contactUs: "联系我们",
    ourBlog: "博客",
    aboutUs: "关于我们",
    sustainability: "可持续发展",
    careers: "职业发展",
  },
  Button: {
    bookNow: "立即预订",
    discoverMore: "了解更多",
    moreDetail: "更多详情",
    moreDetails: "更多详情",
    allOffer: "查看所有优惠",
    viewThisRoom: "查看此客房",
    applyNow: "立即申请",
    viewMap: "查看地图",
    contactUs: "联系我们",
    moreAboutUs: "了解更多",
    enterOurSpaces: "进入我们的空间",
    bookThisRoom: "预订此客房",
    exploreArtsAndAmanaki: "探索艺术与 Amanaki",
    viewAllStories: "查看所有故事",
    viewAll: "查看全部",
    reserve: "预订",
    readMore: "阅读更多",
    exploreMore: "探索更多",
    viewCareers: "查看职业",
    makeAnEnquire: "进行咨询",
    getToKnowOurExecutiveChef: "了解我们的主厨",
    visitOurRestaurant: "访问我们的餐厅",
    seeOurFacilities: "查看我们的设施",
    submit: "提交",
    checkTheMap: "查看地图",
    goToMap: "前往地图",
    requestForProposal: "请求提案",
    bookDirectWithUs: "直接与我们预订",
    back: "返回",
    backToTop: "返回顶部",
  },
  FAQs: {
    FAQs: "常见问题",
    slogan: "我们在这里满足您的所有需求！",
  },
  Stories: {
    title: "启发人心的故事",
    topic: {
      wellness: "健康养生",
      liveLikeLocal: "像当地人一样生活",
      whatOn: "最新动态",
    },
    lastestStories: "最新故事",
    interested: "感兴趣",
    exploreAllStories: "探索所有故事",
    tags: "标签",
    share: "分享故事",
  },
  About: {
    aboutAmanaki: "关于 Amanaki",
    aboutUs: "关于我们",
    sustainableDevelopment: "可持续发展",
    careers: "职业发展",
    sustainable: {
      blogs: {
        heading: "您可能也喜欢",
      },
    },
  },
  Wellness: {
    wellness: "健康养生",
    facilitiesService: "设施与服务",
    gallery: "画廊",
    hours: "营业时间",
    reservations: "预订",
    location: "位置",
    wellbeingCentre: {
      wellbeingCentre: "健康中心",
    },
    facilities: {
      facilities: "设施",
    },
  },
  Dinning: {
    dinning: "餐饮",
    restaurantInfo: {
      title: "餐厅信息",
      cuisine: {
        label: "菜系",
        fusionInspired: "越南融合风味",
        viewMenu: "查看菜单",
      },
      reservations: {
        label: "预订",
        phone: "082 841 1010",
        email: "info@amanaki.vn",
        address: "8 Nguyen Dang Giai, 草甸, 第二区",
      },
      openingHours: {
        label: "营业时间",
        allDay: "全天",
        dinning: "06:00 - 22:00",
        lastOrder: "（最后点餐时间 21:45）",
      },
      executiveChef: {
        label: "主厨",
        name: "Dong Hoang Nam",
      },
      moreInfo: {
        label: "更多信息",
        amanakiFacebook: "Amanaki Facebook",
      },
    },
  },
  MeetingAndEvents: {
    meetingAndEvents: "会议与活动",
    meetingAndCelebrations: "活动与庆典",
    labelBanner: "激发灵感的创意空间",
    overview: {
      title: "Amanaki 草甸酒店的活动与庆典",
      desc: "无论是字面意义还是象征意义，11:11 Espace 都位于 Amanaki 草甸酒店的中心——一个创造和交换故事的临界共存空间。这个 250 平方米的展览和活动空间是当代越南和国际艺术家展示其创作才华的地方，由 11:11 Espace 策划和呈现。如果您希望举办时尚的艺术和社交活动，请与我们联系！",
      phone: "(+84) 82 362 4488",
      email: "info@amanaki.vn",
    },
    requestForProposal: {
      form: {
        fullName: "全名",
        emailAddress: "邮箱地址",
        phoneNumber: "电话号码",
        numberOfAttendees: "预计参加人数",
        desiredSetup: "期望设置",
        desiredSetupOptions: JSON.stringify([
          { label: "宴会", value: "Banquet" },
          { label: "鸡尾酒会", value: "CocktailReception" },
          { label: "剧院式", value: "Theatre" },
          { label: "U 型", value: "Ushape" },
          { label: "其他", value: "Other" },
        ]),
        eventDate: "活动日期",
        note: "活动概述、评论、问题和/或特殊要求",
        condition: {
          readAndAccept: "我已阅读并接受",
          privacyPolicy: "隐私政策",
          keepUpToDateInfo: "我希望接收最新新闻和信息",
        },
      },
    },
  },
  BrandStory: {
    banner: {
      title: "品牌故事",
    },
  },
  Arts: {
    banner: {
      title: "艺术与 Amanaki",
    },
    exhibitions: {
      tabs: JSON.stringify([
        { label: "即将举办的展览", value: "upcomingExhibition" },
        { label: "当前展览", value: "currentExhibition" },
        { label: "往期展览", value: "previousExhibition" },
      ]),
      status: {
        ongoing: "进行中",
        exhibition: "展览",
      },
    },
  },
  LegalNotice: {
    banner: {
      title: "法律声明",
    },
    menuOptions: JSON.stringify([
      { label: "隐私政策", value: "PrivacyPolicy" },
      { label: "Cookie", value: "Cookies" },
      { label: "最优价格保证", value: "BestRateGuaranteed" },
    ]),
    cookies: {
      heading: "Cookie",
      data: JSON.stringify([
        {
          title: `1. 什么是 Cookie？`,
          content: `Cookie 是当您访问我们的网站时存储在您的计算机或移动设备 <i>（如智能手机或平板电脑）</i> 上的小文本文件或信息片段。Cookie 通常包含 Cookie 来源的网站名称、Cookie 的"生命周期" <i>（即 Cookie 在您的设备上保留多长时间）</i>，以及一个值，通常是随机生成的唯一数字。`,
        },
        {
          title: `2. 我们使用 Cookie 的目的是什么？`,
          content: `我们使用 Cookie 使我们的网站更易于使用，并更好地根据您的兴趣和需求定制网站和产品。Cookie 可以做到这一点，因为网站可以读取和写入这些文件，使它们能够识别您并记住重要信息，从而使您使用网站更加方便 <i>（例如，通过记住偏好设置）</i>。Cookie 也可用于帮助加快您在我们网站上的未来活动和体验。我们还使用 Cookie 来编译匿名、汇总的统计数据，使我们能够了解用户如何使用我们的网站，并帮助我们改进网站的结构和内容。我们无法从这些信息中识别您的个人身份。`,
        },
        {
          title: `3. 我们使用哪些类型的 Cookie？`,
          content: `网站上可能使用两种类型的 Cookie，称为"会话 Cookie"和"持久 Cookie"。会话 Cookie 是临时 Cookie，在您离开网站之前一直保留在您的设备上。持久 Cookie 在您的设备上保留更长时间或直到您手动删除它 <i>（Cookie 在您的设备上保留多长时间取决于特定 Cookie 的持续时间或"生命周期"）</i>。
第三方 Cookie
我们还使用许多供应商，当您访问我们的网站时，它们可能会代表我们在您的设备上设置 Cookie，以允许它们提供它们正在提供的服务。如果您想了解有关这些 Cookie 的更多信息，以及如何选择退出接收此类 Cookie 的信息，请参阅其隐私政策。`,
        },
        {
          title: `4. 我们使用哪些 Cookie？`,
          content: [
            {
              text: `下面我们列出了可能在 Amanaki.vn 网站上使用的不同类型的 Cookie。请注意，通过 Cookie 收集的信息构成个人信息的范围内，隐私政策中的条款适用并补充本 Cookie 政策。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">基本 Cookie：</span>
基本 Cookie 是网站运行所必需的，使您能够浏览网站并使用其服务和功能。没有这些绝对必要的 Cookie，网站将无法如我们所愿顺利运行，我们可能无法提供您请求的网站或某些服务或功能。
<span style="font-weight: 405;">会话</span> – 会话 Cookie 用于维护应用程序的状态。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">负载均衡</span> – 负载均衡 Cookie 用于在全球范围内分发资产并减轻服务器负载。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">用户 ID</span> – 用户 ID Cookie 用于确保用户只能看到自己的信息。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">安全</span> – 安全 Cookie 用于安全控制和检查。可以通过浏览器设置接受/拒绝来管理这些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">偏好 Cookie</span>
偏好 Cookie 收集有关您的选择和偏好的信息，并允许我们记住语言或其他本地设置并相应地自定义网站。
<span style="font-weight: 405;">语言</span> – 语言 Cookie 用于存储用户选择的语言，并显示正确的选项。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">位置</span> – 用户的大致地址 <i>（城市、州、国家/地区、邮政编码）</i> 由 IP 地址确定，以便自动选择适当的国家/地区并显示该区域内的零售商和演示日。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">移动设备</span> – 如果用户在移动设备上查看网站，则设置 Cookie 以指示已选择主网站 <i>（即设备已启用 Flash）</i>，或非 Flash 移动网站。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">参考网站</span> – 记录参考网站以更好地了解用户的偏好。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">最后访问和活动</span> – 记录最后访问和活动的日期以及其他信息，以便能够向用户提供"自您上次访问以来网站上的变化"的更新，并更好地了解用户的偏好。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">最近观看的视频</span> – 记录最近观看的视频的日期和标题，以便更好地了解用户的偏好。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">Flash Cookie</span> – Flash Cookie 用于启用音频和视频内容的播放。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">页面历史</span> – 页面历史 Cookie 用于跟踪用户访问的页面序列。如果用户在访问网站时收到错误消息，Cookie 信息将保存到日志文件中以进行错误报告和解决。可以通过浏览器设置接受/拒绝来管理这些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">社交插件跟踪 Cookie</span>
此类 Cookie 用于跟踪社交媒体网络的成员 [和非成员]，用于市场研究分析和产品开发。
<span style="font-weight: 405;">Facebook</span> – Cookie 用于跟踪 Facebook 成员 [和非成员]，用于市场研究分析和产品开发。可以通过浏览器设置接受/拒绝来管理这些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">分析 Cookie</span>
分析 Cookie 收集有关您使用网站的信息，并使我们能够改进其工作方式。例如，分析 Cookie 向我们显示网站上访问最频繁的页面，帮助我们记录您在使用网站时遇到的任何困难，并向我们显示我们的广告是否有效。这使我们能够查看网站上的整体使用模式，而不是单个人的使用情况。
<span style="font-weight: 405;">Google Analytics</span> – Google Analytics Cookie 收集汇总统计数据以改进网站展示和导航。Google 用人口统计和兴趣信息补充汇总数据，以便我们能够更好地了解我们的访问者。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">Adobe Omniture</span> – Adobe Omniture 分析 Cookie 收集汇总统计数据以改进网站展示和导航。可以通过浏览器设置接受/拒绝来管理这些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">营销 Cookie</span>
广告 Cookie 用于营销目的。
<span style="font-weight: 405;">广告</span> – 提供行为/定向广告。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">市场分析</span> – 进行市场分析。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">活动/促销</span> – 衡量活动的有效性。可以通过浏览器设置接受/拒绝来管理这些 Cookie。
<span style="font-weight: 405;">欺诈检测</span> – 检测点击欺诈。可以通过浏览器设置接受/拒绝来管理这些 Cookie。`,
            },
          ],
        },
        {
          title: `5. 如何管理 Cookie？`,
          content: `尽管大多数互联网浏览器最初设置为自动接受 Cookie，但大多数互联网浏览器允许您更改设置以阻止 Cookie 或在 Cookie 发送到您的设备时提醒您。
除了上面提供的选项外，您还可以随时通过激活或访问浏览器上的设置来拒绝、接受或删除网站上的 Cookie。有关启用、禁用或删除 Cookie 所需遵循的程序的信息，可以通过帮助屏幕在您的互联网浏览器提供商的网站上找到。
请注意，如果禁用或删除 Cookie，网站的所有功能可能无法按预期运行，例如，您可能无法访问我们网站的某些区域，或者在访问网站时可能无法接收个性化信息。
如果您使用不同的设备查看和访问网站 <i>（例如您的计算机、智能手机、平板电脑等）</i>，您需要确保每个设备上的每个浏览器都经过调整以适合您的 Cookie 偏好。
如果您想清理您访问过的网站留下的所有 Cookie，您可以找到清理跟踪 Cookie 的第三方网站。
这些第三方网站不在我们的控制之下，我们不对这些网站做出任何陈述或保证。如果您决定访问这些第三方网站，我们建议您在使用该网站之前查看任何第三方网站的相应条款和条件以及隐私政策。`,
        },
        {
          title: `6. 像素标签`,
          content: `您访问的网站上的某些页面也可能通过使用像素标签 <i>（也称为清晰 gif）</i> 收集信息，这些信息可能与直接支持我们的促销活动和网站开发的第三方共享。例如，有关访问我们网站的访问者的网站使用信息可能与我们的第三方广告代理商共享，以便更好地在我们的网站上定位互联网横幅广告。但是，通过使用这些像素标签收集的信息不是个人可识别的，尽管它可能与您的个人信息相关联。`,
        },
        {
          title: `7. 联系我们`,
          content: `如果您对此 Cookie 政策有任何疑问，请通过 <a href="mailto:info@amanaki.vn" style="color: #af915e">info@amanaki.vn</a> 与我们联系。请注意，电子邮件通信并不总是安全的，因此请不要在您发送给我们的电子邮件中包含信用卡信息或敏感信息。`,
        },
      ]),
    },
    bestRateGuaranteed: {
      heading: "最优价格保证",
      title: "直接通过 AMANAKI 预订，保证最优价格。",
      data: JSON.stringify([
        {
          content: `您在 Amanaki 的住宿，从开始到结束，都是我们的优先事项。当您直接在我们的官方网站上预订住宿时，这段旅程就开始了，您将得到保证：`,
        },
        {
          content: [
            `您住宿的最低价格`,
            `最灵活的取消条款`,
            `访问我们专门的预订专家以帮助您预订`,
            `在整个住宿期间享受最佳服务`,
            `如果您在预订后 24 小时内找到更低的合格价格，我们将匹配较低的价格。`,
          ],
        },
      ]),
    },
  },
  HomeHotel10: {
    experiencing: {
      title: "体验 Amanaki",
    },
  },
  Offers: {
    offer: "优惠",
  },
  Offer: {
    valid: "有效期至 {{date}}",
    otherOffer: "其他优惠",
  },
  ContactUs: {
    description: `如果您对我们的酒店、酒店预订或在我们的餐厅或健康中心预订有任何疑问，请联系我们。`,
    getInTouch: "保持联系",
    descInTouch: `我们很高兴收到您的来信，请使用下面的详细信息与我们联系。`,
    iConfirm: "我确认我已阅读并理解 Amanaki 酒店",
    privacy: "隐私政策",
    acceptReceiveInfomation:
      "是的！我希望接收来自 Amanaki 酒店的特殊优惠和促销活动，包括酒店、餐饮和水疗促销",
    addressAmanakiThaoDien: `10 Nguyen Đang Giai, 草甸区, 守德市, 胡志明市`,
    addressAmanakiSaigonBoutique: `65 Ho Tung Mau, 本义区, 第一区, 胡志明市`,
  },
  Discover: {
    title: "探索西贡",
    description:
      "\"每座建筑，每个店面，似乎都通向一个不同的世界，将人类生活的所有多样性压缩成各种可能性的混合体，通过连接而变得更加丰富。\"<0/>Rebecca Solnit",
    BlockLocation: {
      distanceAmanaki: "从 Amanaki 出发的方向：",
      checkMap: "查看地图",
    },
    BlockOurLocation: {
      ourLocation: "我们的位置",
      getting: "前往 Amanaki<0/>草甸酒店",
      address: "10 Nguyen Dang Giai 街, 草甸区, 守德市, 胡志明市",
      phone: "(+84) 82 3624488",
      airport: "新山一国际机场",
      airportDescription: `从新山一国际机场<0/>
距离酒店：13 公里<0/>
机场班车服务：500,000 越南盾/次`,
      tel: "电话",
    },
  },
  Breadcrumb: {
    stories: "我们的故事",
    category: "类别",
    amanakiThaoDien: "Amanaki 草甸酒店",
    "amanaki-thao-dien": "Amanaki 草甸酒店",
    "amanaki-boutique-saigon": "Amanaki 西贡精品酒店",
    theHotel: "酒店",
  },
  Rooms: {
    Signature: "签名",
    Executive: "行政",
    Premium: "高级",
    FamilySuite: "家庭套房",
    otherRooms: "其他客房",
    theDetails: "详情",
    utilities: "设施",
    amenities: "便利设施",
    checkIn: "入住",
    checkOut: "退房",
    visitOurRooms: "参观我们的客房",
    Banner: {
      title: "参观我们的客房",
      description: `放慢脚步，睁大眼睛。<0/>在里面，一段历史正在温柔地看着您。`,
    },
  },
  DateFormat: {
    Default: "DD/MM/YYYY",
    FullDisplay: "HH:mm:ss - DD/MM/YYYY",
    Unit: {
      second: "秒",
      minute: "分钟",
      hour: "小时",
    },
    Time: "LT",
  },
  SearchControl: {
    room: "客房",
    adults: "成人",
    children: "儿童",
    bestPrice: "保证最优价格",
    checkAvailability: "检查可用性",
  },
  Time: {
    minutes: "{{n}} 分钟",
  },
  Filter: {
    clearFilter: "清除筛选",
    categoryPlaceholder: "类别",
    placeholderCategory: "类别",
    sortPlaceholder: "排序",
    lastestLabel: "最新文章",
    oldestLabel: "最旧文章",
  },
  Error: {
    pageNotFound: "页面未找到",
    pageNotFoundDescription: "您要查找的页面不存在或已被移动。",
    serverError: "服务器错误",
    serverErrorDescription: "服务器出现了问题。请稍后再试。",
    goHome: "返回首页",
  },
  CookieConsent: {
    message: "我们使用 Cookie 来改善您的体验并分析网站流量。点击接受即表示您同意我们使用 Cookie。请参阅我们的",
    privacyPolicy: "隐私政策",
    acceptAll: "全部接受",
    rejectAll: "全部拒绝",
    managePreferences: "管理偏好设置",
    preferencesTitle: "Cookie 偏好设置",
    preferencesDescription: "选择您允许的 Cookie。您可随时更改这些设置。了解更多请参阅我们的",
    savePreferences: "保存偏好设置",
    cancel: "取消",
    categoryNecessary: "必要 Cookie",
    categoryFunctional: "功能 Cookie",
    categoryAnalytics: "分析 Cookie",
    categoryMarketing: "营销 Cookie",
    alwaysRequired: "始终开启",
    categoryNecessaryDesc: "网站运行所必需，无法禁用。",
    categoryFunctionalDesc: "记住您的偏好设置，如语言和地区。",
    categoryAnalyticsDesc: "帮助我们了解访客如何使用网站以进行改进。",
    categoryMarketingDesc: "用于个性化广告和营销活动。",
    toggleLabel: "切换 Cookie 类别",
    cookiePreferences: "Cookie 偏好设置",
  },
};
export default zh;

